import hydrate from '../common/hydrate';
import CommonInspirationalTeaser from './components/CommonInspirationalTeaser';
import { root, name } from './manifest.json';
hydrate(CommonInspirationalTeaser, root, name);
if (module.hot) {
    module.hot.accept();
}
